import { RedirectDto } from "@intelligems/ig-types/dtos/redirects";
import { getPreviewUrl } from "@src/features/experiments/components/redirects/templateTest/util";

export const generateShopifyEditorUrl = ({
  shopId,
  themeId,
  redirectType,
  redirect,
  matchedHandle,
  index,
  isPersonalization,
  view,
}: {
  shopId: string;
  themeId: string;
  redirectType: "theme" | "template";
  redirect?: RedirectDto;
  matchedHandle?: string;
  index?: number;
  isPersonalization?: boolean;
  view?: string;
}): string => {
  const baseStoreUrl = `https://admin.shopify.com/store/${
    shopId.split(".")[0]
  }/themes/${redirectType === "theme" ? view : themeId}?key=layout%2Ftheme.liquid`;

  if (redirect?.isTemplateTest && matchedHandle !== undefined && view) {
    return getPreviewUrl({
      redirectState: redirect,
      matchedHandle,
      index: index ?? 0,
      isPersonalization: isPersonalization ?? false,
      storeUrl: `${baseStoreUrl}?previewPath=`,
      screenshot: false,
    });
  }

  return baseStoreUrl;
};
